module.exports = __webpack_public_path__ + "img/hzm-active.b27d4555.png";